import { withInstall } from '@bigin/utils'

import Icon from './src/icon.vue'

export const BIcon = withInstall(Icon)
export default BIcon

export * from './src/icon'
